import { ContractingProcessAnswerProps } from "features/contracting/models/ContractingProcessAnswerProps";
import { setNoFixedContratDurationSubForms } from "features/contracting/sections/contractingForms/processForm/processFormValidation";
import PageCard from "features/shared/components/card/PageCard";
import DatePicker from "features/shared/components/reactDates/DatePicker";
import FormGroup from "features/shared/forms/components/FormGroup";
import { useTranslationWithPrefix } from "features/shared/hooks/useTranslationWithPrefix";
import React, { useEffect } from "react";

interface Props extends ContractingProcessAnswerProps {}

const NoFixedContratDurationSubForm = ({ formHandler }: Props) => {
  //translations
  const tLabels = useTranslationWithPrefix("contracting\\contracting", "noFixedContratDurationSubForm");

  // form hook props
  const {
    bindDatePickerField,
    clearFormValues,
    setValidationRule,
    errors,
  } = { ...formHandler };

  // side-effects
  useEffect(() => {
    // set default validations
    setNoFixedContratDurationSubForms(setValidationRule);

    return () => {
      // before unmount component remove values and validations
      setNoFixedContratDurationSubForms(setValidationRule, "remove");
      clearFormValues(["noFixedContratDuration"]);
    };
  }, []);

  // render
  return (
    <PageCard
      title={tLabels("contractEffectiveDateCardTitle")}
      bodyClassName="pt-4 px-4"
      cardClassName="mb-4"
    >
      <div className="col-md-6 pl-0 pr-0 pr-md-2">
        <FormGroup
          labelText={tLabels("contractEffectiveDate")}
          inputId="noFixedContratDuration.contractEffectiveDate"
          validationError={errors["noFixedContratDuration.contractEffectiveDate"]}
        >
          <DatePicker
            {...bindDatePickerField("noFixedContratDuration.contractEffectiveDate")}
            onlySelectable
            minDate={new Date()}
          />
        </FormGroup>
      </div>
    </PageCard>
  );
}

export default NoFixedContratDurationSubForm;